const userInfoServiceConstants = Object.freeze({
   groups: {
       externalTbUsers: "External Partners",
       internalTbUsers: "Internal TrackerBase Users",
       trackers: "Trackers",
       trackingManagers: "Tracking Managers",
       admins: "TrackerBase Admins"
   }
});

export default userInfoServiceConstants;



//////////////////
// WEBPACK FOOTER
// ./src/services/UserInfoServiceConstants.js
// module id = wA1c
// module chunks = 1